/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ViewColumnType {
  Self = 'Self',
  Text = 'Text',
  Boolean = 'Boolean',
  Number = 'Number',
  Enum = 'Enum',
  Date = 'Date',
  DateTime = 'DateTime',
  Duration = 'Duration',
  Currency = 'Currency',
  Status = 'Status',
  Answer = 'Answer',
  PhoneAddress = 'PhoneAddress',
  ElectronicAddress = 'ElectronicAddress',
  Reference = 'Reference',
  Activity = 'Activity',
  Avatar = 'Avatar',
  Pipeline = 'Pipeline',
  Sla = 'Sla',
  FileIndex = 'FileIndex',
  Icon = 'Icon',
  ClientSummary = 'ClientSummary',
  Identities = 'Identities',
  Url = 'Url',
  Toggle = 'Toggle',
  Order = 'Order'
}
